export const GuestConstant = {
  GET_CHAPTER: 'GET_CHAPTER',
  CHAPTER_LIST: 'CHAPTER_LIST',
  INSERT_ENQUIRY: 'INSERT_ENQUIRY',
}